import React from 'react'
import StepsComponent from '../components/steps'
import axios from 'axios'
import _ from 'lodash'
import jsonToFormData from '@ajoelp/json-to-formdata'
import { Component } from 'react'

class IndexPage extends Component {
  constructor (props) {
    super(props)
    this.state = {
      draft: {
        masterStep: 0,
        subStep: 0,
        user_idFk: this.props.userId,
        user: this.props.user
      },
      loading: false,
      hasError: false
    }
  }

  async componentDidMount () {
    // axios.defaults.headers['Authorization'] = `Bearer ${_.get(this.props, 'api_token')}`
    axios.defaults.headers['Content-Type'] = `application/json`
    axios.defaults.headers['Accept'] = `application/json`
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  async componentDidCatch (error, errorInfo) {
    await axios.post(`${process.env.REACT_APP_API_URL}/api/propertylisting/notify/failed`, jsonToFormData({
      message: `${_.toString(error)} ${errorInfo.componentStack}`
    }), {
      headers: {
        "Content-Type": 'multipart/form-data;'
      }
    })
  }

  render () {
    if (this.state.hasError || this.state.loading) {
      return null
    }
    return <StepsComponent draft={this.state.draft} setProgress={this.props.setProgress} progress={this.props.progress} />
  }
}

export default IndexPage
